import { safeJson } from "src/app/helpers/Index";
import { faArrowRightFromBracket, faBoxArchive, faFireBurner, faHouseBlank, faPlateUtensils, faRectangleHistory, faStar, faUser, faUserChef } from "@fortawesome/pro-light-svg-icons";
import { faCircleDot } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Badge } from "primereact/badge";
import { Dialog } from "primereact/dialog";
import { Menu } from "primereact/menu";
import { ProgressSpinner } from "primereact/progressspinner";
import React from "react";
import { Link, Navigate, NavLink, Outlet } from "react-router-dom";
import { User } from "src/app/interfaces/Index";
import { AppSettingsService, UserService } from "src/app/services/Index";
import { colours } from "src/app/Styles";
import { environment } from "src/environments/environment";
import "./VisitorMain.css";

type Props = {};
type State = {
	canCloseFirstTimeLoginModal: boolean;
	isLoggedIn?: boolean;
	isWelcomeDataLoading: boolean;
	mobileTopbarMenuClick: boolean;
	menuItems: any[];
	redirectToMyKitchen: boolean;
	showFirstTimeLoginModal: boolean;
	user?: User;
};
export class VisitorMain extends React.Component<Props, State> {
	constructor(props: Props) {
		super(props);
		this.state = {canCloseFirstTimeLoginModal: false, isWelcomeDataLoading: false, mobileTopbarMenuClick: false, menuItems: [], redirectToMyKitchen: false, showFirstTimeLoginModal: false};
	}

	componentDidMount() {
		this.isUserLoggedIn();
	}

	getMenuItems() {
		this.setState({menuItems: [
			{
				label: "Home",
				items: [{
					icon: faHouseBlank, label: "Dashboard", template: (item: any) => this.renderMenuItem(item), to: `/${environment.build.visitorRoute}/home`
				}]
			},
			{
				label: "My Dishes",
				items: [
					{ icon: faPlateUtensils, label: "All Dishes", template: (item: any) => this.renderMenuItem(item), to: `/${environment.build.visitorRoute}/home/my-dishes` },
					{ icon: faBoxArchive, label: "Archive", template: (item: any) => this.renderMenuItem(item), to: `/${environment.build.visitorRoute}/home/my-archived-dishes` }
				]
			},
			{
				label: "Orders",
				items: [
					{ icon: faFireBurner, label: "Pending Orders", template: (item: any) => this.renderMenuItem(item), to: `/${environment.build.visitorRoute}/home/pending-orders` },
					{ icon: faRectangleHistory, label: "Past Orders", template: (item: any) => this.renderMenuItem(item), to: `/${environment.build.visitorRoute}/home/past-orders` }
				]
			},
			{
				label: "Account",
				items: [
					{icon: faUserChef, label: "My Kitchen", template: (item: any) => this.renderMenuItem(item), to: `/${environment.build.visitorRoute}/home/my-kitchen`},
					{icon: faStar, label: "My Reviews", template: (item: any) => this.renderMenuItem(item), to: `/${environment.build.visitorRoute}/home/my-reviews`},
					{icon: faUser, label: "My Account", template: (item: any) => this.renderMenuItem(item), to: `/${environment.build.visitorRoute}/home/my-account`},
					{icon: faArrowRightFromBracket, label: "Sign Out", template: (item: any) => this.renderMenuItemSignOut(item)}
				]
			},
		]});
	}

	async getUser() {
		const res = await safeJson(UserService.me());
		if (res === null) this.setState({isLoggedIn: false});
		else {
			this.setState({isLoggedIn: true, user: new User(res)});
		}
	}

	async isUserLoggedIn() {
		const res = await safeJson(UserService.loginCheck("Visitors"));
		if (res === true) {
			this.setState({isLoggedIn: true});
			this.getUser();
		} else this.setState({isLoggedIn: false});
	}

	mobileTopbarMenuClick(event: any) {
		this.setState({mobileTopbarMenuClick: !this.state.mobileTopbarMenuClick});
		event.preventDefault();
	}

	render() {
		if (this.state.isLoggedIn === true) return this.renderMain();
		else if (this.state.isLoggedIn === false) return this.renderLogin();
		else return;
	}

	renderLogin() {
		return (
			<Navigate replace={true} to={`/${environment.build.visitorRoute}`}/>
		);
	}

	renderMain() {
		return (
			<div style={{backgroundColor: "#EDF1F5", minHeight: "100vh", paddingTop: "4rem"}}>
				<div className="layout-topbar">
					<button type="button" className="p-link layout-topbar-menu-button layout-topbar-button" onClick={(event) => this.mobileTopbarMenuClick(event)}>
						<i className="pi pi-ellipsis-v"/>
					</button>
					<Link className="layout-topbar-logo" style={{textDecoration: "none"}} to={`/${environment.build.visitorRoute}`}>
						<img src="/assets/Logo_Dark.png" style={{height: 40}}></img>
					</Link>
				</div>
				<Menu model={this.state.menuItems}/>
				<div style={{marginLeft: 364, marginRight: 32, marginTop: 32, paddingBottom: 32, width: "calc(100% - 396px)"}}>
					<Outlet/>
				</div>
				{this.state.redirectToMyKitchen &&
					<Navigate replace={true} to={`/${environment.build.visitorRoute}/home/my-kitchen`}/>
				}
			</div>
		);
	}

	renderMenuItem(item: any) {
		return (
			<NavLink className="p-menuitem-link" end style={{position: "relative"}} to={item.to}>
				<FontAwesomeIcon icon={item.icon} style={{color: colours.black, fontSize: 15, width: 40}}/>
				<span className="p-menuitem-text">{item.label}</span>
				{item.badge &&
					<Badge style={{backgroundColor: colours.primary, position: "absolute", right: 10}} value={item.badge}></Badge>
				}
			</NavLink>
		);
	}

	renderMenuItemSignOut(item: any) {
		return (
			<div className="p-menuitem-link" onClick={() => this.signOut()} style={{position: "relative"}}>
				<FontAwesomeIcon icon={item.icon} style={{color: colours.error, fontSize: 15, width: 40}}/>
				<span className="p-menuitem-text" style={{color: colours.error}}>{item.label}</span>
			</div>
		);
	}

	async signOut() {
		await AppSettingsService.remove("accessToken");
		await AppSettingsService.remove("refreshToken");
		this.setState({isLoggedIn: false});
	}
}